import React, { useState, useRef, useEffect } from "react";
import { Grid, Segment, Input, Table, Dropdown } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Config } from "../common"
import { useHistory } from "react-router-dom";
import NoOrderHistory from "./NoOrderHistory";
import { useSelector, useDispatch } from 'react-redux'
import { getParticipationHistory, setPartDetails } from "../store/OrderRedux"
import { setTriviaInfo, detailAllTrivias } from '../store/TriviaRedux'
import searchicon from "../assets/home/searchicon.svg";
import InfiniteScroll from 'react-infinite-scroll-component';
import onging from "../assets/home/onging_img.png";
import Loading from './Loading'

const options = [
  { key: 1, text: 'Winner', value: 'winner' },
  { key: 2, text: 'Ongoing', value: 'ongoing' },
  { key: 3, text: 'Completed', value: 'completed' },
]

const ContestList = ({ isStatus = false }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const history = useHistory();
  const [search, setSearch] = useState('')
  const [type, setType] = useState('')
  const [page, setPage] = useState(1)
  const timer = useRef();
  const pageActive = useRef(false);
  const token = useSelector((state) => state.auth.token)
  const participationHistory = useSelector((state) => state.order.participationHistory)
  const isFetching = useSelector((state) => state.order.isFetching)
  const singleTrivias = useSelector((state) => state.trivia.singleTrivias)

  useEffect(() => {
    if (token) {
      let param = { token, pageNo: 1, pageSize: 10, }
      if (isStatus) {
        param.status = 'completed'
      }
      dispatch(getParticipationHistory(param))
    }
  }, []);


  useEffect(() => {
    if (singleTrivias && pageActive.current) {
      dispatch(setTriviaInfo(singleTrivias))
      pageActive.current = false;
      history.push(`/payment`)
    }
  }, [singleTrivias]);

  const handleSearch = (value1 = null, value2 = null) => {
    let searchs = value1 ? value1 : search
    let types = value2 ? value2 : type

    let param = { token, pageNo: 1, pageSize: 10, }
    if (isStatus) {
      param.status = 'completed'
    }
    if (types) {
      param.status = types
    }
    if (searchs) {
      param.title = searchs
    }
    clearInterval(timer.current);
    timer.current = setTimeout(() => {
      dispatch(getParticipationHistory(param))
    }, 500)
  }

  let orders = participationHistory?.data ? participationHistory?.data : []

  const fetchData = () => {
    if (orders.loadMore) {
      setPage(page + 1)
      let param = { pageNo: page, pageSize: 10, token }
      if (isStatus) {
        param.status = 'completed'
      }
      if (type) {
        param.status = type
      }
      if (search) {
        param.title = search
      }
      dispatch(getParticipationHistory(param))
    }
  }

  const refreshData = () => {

  }

  const showStatus = (item, newDate) => {
    if (item?.contestant?.winner && newDate > 0) {
      return <div className="top_list top_list3"><span>#Top 100</span></div>
    }
    if (item?.trivia?.status == 'completed') {
      return <div className="top_list"><span>Completed</span></div>
    }
    if (item?.trivia?.status == 'ongoing') {
      return <div className="top_list top_list2"><span>Ongoing</span></div>
    }
    return null
  }

  if (!token || orders && orders.length == 0) {
    return <NoOrderHistory />
  }

  return (
    <>
      <div className="conten">
        <div className="input_box clearall">
          {!isStatus && (<div className="part_sec">
            <img className="onging_img" src={onging} />
            <Dropdown value={type} onChange={(e, { value }) => {
              setType(value)
              handleSearch(null, value)
            }} selection options={options} placeholder='Status' className="drop" />
          </div>)}
          <div className="search_sec">
            <img className="searchicon" src={searchicon} />
            <Input value={search} onChange={(e) => {
              setSearch(e.target.value)
              handleSearch(e.target.value, null)
            }} placeholder='Search' />
          </div>
        </div>
      </div>

      <div className="inner_bg destops">
        {isFetching && (<Loading />)}
        <div className="celebrity">
          <Table>
            <Table.Row>
              <Table.HeaderCell><h4>entries</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Latest entry</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>end date</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>contest name</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Your time</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Leader’s time</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>Action</h4></Table.HeaderCell>
              <Table.HeaderCell><h4>details</h4></Table.HeaderCell>
            </Table.Row>
          </Table>
        </div>
        <div className="text"></div>
        <div className="scrolls-y" style={{ height: 400 }}>
          <div className="text"></div>
          <InfiniteScroll
            dataLength={orders?.length} //This is important field to render the next data
            next={fetchData}
            hasMore={true}
            loader={<h4>Loading...</h4>}
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
            // below props only if you need pull down functionality
            refreshFunction={refreshData}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
            }
          >
            {orders.map((item, key) => {
              // let basicDetails = Config.GetLanguage(item?.trivia, i18n.language, 'basicDetails')
              // console.log(basicDetails)
              // console.log(item)
              let newDate = moment.utc(Config.localUtc()) - moment.utc(item?.trivia?.resultDate)
              return <div key={key} className="amount">
                {showStatus(item, newDate)}
                <Table>
                  <Table.Row>
                    <Table.HeaderCell><h4>{item?.entries}</h4></Table.HeaderCell>
                    <Table.HeaderCell><h4>{moment.utc(item?.contestant?.createdAt).format('Do MMM, YYYY')}</h4></Table.HeaderCell>
                    <Table.HeaderCell><h4>{moment.utc(item?.trivia?.endDate).format('Do MMM, YYYY')}</h4></Table.HeaderCell>
                    <Table.HeaderCell><h4>{item.triviaName}</h4></Table.HeaderCell>
                    <Table.HeaderCell><h4>{Config.parseDuration(item?.contestant?.timeTaken)}</h4></Table.HeaderCell>
                    <Table.HeaderCell><h4>{Config.parseDuration(item?.trivia?.leaderTime)}</h4></Table.HeaderCell>
                    <Table.HeaderCell className="resultGray">
                      {item?.trivia?.status == 'ongoing' ? <a onClick={() => {
                        dispatch(detailAllTrivias({ id: item.trivia._id, token }))
                        pageActive.current = true;
                      }}>Try Again</a> : (item?.trivia?.winnerPlayers?.length > 0 && newDate > 0) ? <a onClick={() => {
                        history.push(`/leaderboard/${item?.trivia?._id}`)
                      }}>View result</a> : "View Result"}
                    </Table.HeaderCell>
                    <Table.HeaderCell><a onClick={() => {
                      history.push(`/participationDetails/${item?.trivia?._id}`)
                      dispatch(setPartDetails(item))
                    }}>View details</a></Table.HeaderCell>
                  </Table.Row>
                </Table>
              </div>
            })}
          </InfiniteScroll>
          <div className="text"></div>
        </div>
      </div>

      <div className="mobiles clearall scrolls-y" style={{ height: 400 }}>
        {orders.map((item, key) => {
          let newDate = moment.utc(Config.localUtc()) - moment.utc(item?.trivia?.resultDate)
          return <div key={key} className="sarukhu">
            {showStatus(item, newDate)}
            <div style={{ textAlign: 'center', padding: '10px 0', }}>
              <h4>{item.triviaName}</h4>
              <h5>Total entries : {item?.entries}</h5>
            </div>

            <div className="answered">
              <h4>Latest entry :{moment.utc(item?.contestant?.createdAt).format('Do MMM, YYYY')}</h4>
              <h5>End date : {moment.utc(item?.trivia.endDate).format('Do MMM, YYYY')}</h5>

            </div>
            <div className="answered">
              <h4>Your time : {Config.parseDuration(item?.contestant?.timeTaken)}</h4>
              <h5>Leader’s time: {Config.parseDuration(item?.trivia?.leaderTime)}</h5>
            </div>
            <div className="answered answere_sec">
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <h3><a onClick={() => {
                      dispatch(setPartDetails(item))
                      history.push(`/participationDetails/${item?.trivia?._id}`)
                    }}>View Details</a></h3>
                  </Grid.Column>
                  <Grid.Column>
                    <h3 className="resultGray">{item?.trivia?.status == 'ongoing' ? <a onClick={() => {
                      dispatch(detailAllTrivias({ id: item.trivia._id, token }))
                      pageActive.current = true;
                    }}>Try Again</a> : (item?.trivia?.winnerPlayers?.length > 0 && newDate > 0) ? <a onClick={() => {
                      history.push(`/leaderboard/${item?.trivia?._id}`)
                    }}> View Result</a> : "View Result"}</h3>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        })}
      </div>

    </>
  );
};



export default ContestList;
